import { useState } from "react";
import { useEffect } from "react";
import {
  getCandidatePresentationValues,
  patchCandidatePresentation,
} from "../../API/Candidates/Presentation";
import { PresentationIcon } from "../../Icons/CollaboratorsIcons";
import UploadService from "../../API/Upload/UploadService";
import Loading from "../../Components/Loading/Loading";
import PresentationFiles from "./Components/Presentation/PresentationFiles";
import PresentationForm from "./Components/Presentation/PresentationForm";

import "./presentation.sass";
import { presentationTranslate } from "../../i18n/translatedMessages";

const Presentation = () => {
  const [pdfFile, setPdfFile] = useState({ index: null, file: [] });
  const [presentation, setPresentation] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const REGEXRule = /(documents\/candidates\/).*(.pdf)/g;

  const objEmpty = {
    linkedin: "",
    instagram: "",
    facebook: "",
    curriculum_url: "",
    video_presentation_url: "",
    about_me: "",
  };

  const [presentationData, setPresentationData] = useState(objEmpty);
  const [urlPdf, setUrlPdf] = useState(null);
  useEffect(() => {
    setIsLoading(true);

    async function fetchData() {
      const resp = await getCandidatePresentationValues(localStorage.getItem("candidateId"));
      if (resp.items) {
        setPresentationData(resp.items);

        if (resp.items.curriculum_url !== null && resp.items.curriculum_url.startsWith("http")) {
          const pdfAux = resp.items.curriculum_url.match(REGEXRule);
          setPresentationData((prevState) => ({
            ...prevState, // Copiar el estado anterior
            curriculum_url: pdfAux[0], // Actualizar la propiedad deseada
          }));
        }
        setUrlPdf(resp.items.curriculum_url);
        if (resp.items.video_presentation_url) {
          getYoutubeVideoId(resp.items.video_presentation_url);
        }
        setIsLoading(false);
      }
      setIsLoading(false);
    }
    fetchData();
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const id = localStorage.getItem("candidateId");
    if (pdfFile && pdfFile.index !== null) {
      let fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        const auxArray = [...presentation];
        if (auxArray[pdfFile?.index]) {
          auxArray[pdfFile?.index][
            String("pdf")
          ] = `documents/candidates/${id}/presentation/${pdfFile.file.name}`;
          auxArray[pdfFile?.index][String("pdfName")] = `${pdfFile.file.name}`;
          setPresentation(auxArray);
        }
      };
      fileReader.readAsDataURL(pdfFile.file);
      const auxArrayDataToSend = { ...presentationData };
      auxArrayDataToSend.curriculum_url = `documents/candidates/${id}/presentation/${pdfFile.file.name}`;
      setPresentationData(auxArrayDataToSend);
      setIsLoading(false);
    }
  }, [pdfFile]);

  const handlePatch = async () => {
    setIsLoading(true);
    const hash = localStorage.getItem("hash");
    const id = localStorage.getItem("candidateId");
    const fileName = pdfFile.file.name;

    const { url } = await UploadService.getAuthorizationUploadPresentationFile(fileName, hash, id);
    const respUpload = await UploadService.UploadFile(url, pdfFile.file, "pdf");

    const respPostCandidate = await patchCandidatePresentation(
      presentationData,
      localStorage.getItem("candidateId")
    );
    setIsLoading(false);

    window.location.reload();
  };

  const regexPDFUrl = () => {
    const pdfAux = presentationData?.curriculum_url.match(REGEXRule);
    setPresentationData((prevState) => ({
      ...prevState, // Copiar el estado anterior
      curriculum_url: pdfAux[0], // Actualizar la propiedad deseada
    }));
  };

  const [aboutMeCurrentChart, setaboutMeCurrentChart] = useState(200);
  const [showAboutMeCurrentChar, setShowAboutMeCurrentChar] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "about_me") {
      setaboutMeCurrentChart(200 - value.length);
      setShowAboutMeCurrentChar(true);
    }
    setPresentationData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [videoUrlEmbed, setVideoUrlEmbed] = useState(null);

  const getYoutubeVideoId = (url) => {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? setVideoUrlEmbed(match[7]) : false;
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div className="presentation-container">
            <div className="row mb-4 title-presentation">
              <div className="col-1">
                <span className="title-icon p-2 m-auto">
                  <PresentationIcon />
                </span>
              </div>
              <div className="col-8">
                <h1>{presentationTranslate.presentationTitle}</h1>
                <p className="description-section">{presentationTranslate.presentationDesc}</p>
              </div>
            </div>
            <div className="row d-flex justify-content-center">
              <div className="col-4">
                <PresentationFiles
                  urlPdf={urlPdf}
                  videoUrlEmbed={videoUrlEmbed}
                  presentationData={presentationData}
                  handleChange={handleChange}
                  aboutMeCurrentChart={aboutMeCurrentChart}
                  showAboutMeCurrentChar={showAboutMeCurrentChar}
                />
              </div>
              <div className="col-4">
                <PresentationForm
                  urlPdf={urlPdf}
                  videoUrlEmbed={videoUrlEmbed}
                  presentationData={presentationData}
                  setPdf={setPdfFile}
                  index={0}
                  handlePatch={handlePatch}
                  handleChange={handleChange}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Presentation;
